import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from 'antd';
import { redirectPath } from '../../config/config';

const titleStyles = `
@keyframes title-fade-in {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes title-bar-grow {
  from { width: 0; opacity: 0; }
  to   { width: 100%; opacity: 1; }
}
@keyframes home-icon-beat {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.2); }
}
.cp-title-wrap {
  width: 100%;
  margin-bottom: 18px;
  animation: title-fade-in 0.4s ease both;
}
.cp-title-inner {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 10px;
  flex-wrap: wrap;
}
.cp-title-link {
  font-size: 12px;
  font-weight: 600;
  color: #1890ff !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  text-decoration: none !important;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: color 0.2s;
}
.cp-title-link:hover { color: #40a9ff !important; }
.cp-title-link .anticon {
  animation: home-icon-beat 2.4s ease-in-out infinite;
}
.cp-title-sep { color: #bfbfbf; font-size: 12px; }
.cp-title-current {
  font-size: 13px;
  font-weight: 700;
  color: #262626;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cp-title-bar {
  height: 2px;
  background: linear-gradient(90deg, #1890ff, #13c2c2 60%, transparent);
  border-radius: 2px;
  animation: title-bar-grow 0.5s ease 0.1s both;
}
`;

function Title({ title }) {
  const pathname = useLocation().pathname;

  return (
    <>
      <style>{titleStyles}</style>
      <div className="cp-title-wrap">
        <div className="cp-title-inner">
          <Link to={redirectPath} className="cp-title-link">
            <Icon type="home" />
            Dashboard
          </Link>
          <span className="cp-title-sep">›</span>
          <Link to={pathname} className="cp-title-current" style={{ textDecoration: 'none', color: '#262626' }}>
            {title}
          </Link>
        </div>
        <div className="cp-title-bar" />
      </div>
    </>
  );
}

export default Title;